export const ACTION_TYPES = {
  SET_INITIAL_DATA: "SET_INITIAL_DATA",
  SET_ALL_QUERIES: "SET_ALL_QUERIES",
  SET_SELECTED_QUERY: "SET_SELECTED_QUERY",
  SET_PORT_OPERATIONS: "SET_PORT_OPERATIONS",
  UPDATE_PORT_OPERATION: "UPDATE_PORT_OPERATION",
  REORDER_PORT_OPERATIONS: "REORDER_PORT_OPERATIONS",
  ADD_PORT_OPERATION: "ADD_PORT_OPERATION",
  DELETE_PORT_OPERATION: "DELETE_PORT_OPERATION",
  SET_FLEET_LIST: "SET_FLEET_LIST",
  SET_SELECTED_VESSEL: "SET_SELECTED_VESSEL",
  SET_PORT_DISTANCES: "SET_PORT_DISTANCES",
  SET_CALCULATION_RESULT: "SET_CALCULATION_RESULT",
  SET_LOADING: "SET_LOADING",
  SET_ERROR: "SET_ERROR",
  RESET_STATE: "RESET_STATE",
  SET_IS_OVERRIDE: "SET_IS_OVERRIDE",
};
